// extracted by mini-css-extract-plugin
export default {"cards":"ProjectTeam_cards__lteOd"};